



import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {FadePlate} from "@nolimitcity/slot-game/bin/timelinegameround/components/FadePlate";
import {HarlequinBackground} from "../../background/HarlequinBackground";
import {Harlequin} from "../../Harlequin";

export class HarlequinFreespinOutroView extends StandardAutoCloseGameModeTransitionView  {

    private _totalWin:number;
    //private _totalRespinWin:number;
    private _winRatio:number = 0;
    protected _fullScreenFade:FadePlate;

    protected _bonusSpineSplashSprite:PIXI.Sprite;
    protected _bonusSplashSpine:PIXI.spine.Spine;
    protected _toMode:string;

    protected _finishCalled:boolean = false;
    private _animationLayer:ScalableLayer;

    protected _screenRect:PIXI.Rectangle;

    private _tl:Timeline | null;

    private _compCallback:() => void;

    private _winBelowStack:boolean;

    constructor(layer:ScalableLayer, autoCloseTimerDuration:number = 20) {
        super(layer, autoCloseTimerDuration);

        this._animationLayer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.FS_OUTRO.name);
    }

    protected initAnimations():void {
        this._deviceScale = UserAgent.isMobile ? this.MOBILE_SCALE : 1;
        this._button = this.createButton();

        this._autoCloseTimer = this.createAutoCloseTimer();

        this._mainGraphicsContainer = new PIXI.Container();
        this._mainGraphicsContainer.addChild(this.createBackground());
        this._mainGraphicsContainer.addChild(this.createGameGraphics());
        this._mainGraphicsContainer.alpha = 1;

        this._fullScreenFade = new FadePlate(0x000000, 1);
        this._mainGraphicsContainer.addChild(this._button);

        this.createSplash();
        this.addChild(this._mainGraphicsContainer);
        this._mainGraphicsContainer.renderable = false;
    }

    protected createSplash():void {
        const sprite:PIXI.Sprite = new PIXI.Sprite();
        sprite.anchor.set(0.5, 0.5);
        sprite.visible = false;

        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bonusWinSumSpine"));

        sprite.addChild(spine);
        this._bonusSpineSplashSprite = sprite;
        this._bonusSplashSpine = spine;

        this._bonusSplashSpine.stateData.setMix("Start", "idle", 0.15);

        this._animationLayer.addChild(this._bonusSpineSplashSprite);
    }

    protected createBackground():PIXI.DisplayObject {
        return new PIXI.Container();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        return new PIXI.Container();
    }

    public startTimerAndEnableButton(callback:() => void) {
        this._compCallback = callback;
        //this._button.enabled = true;
        this._button.visible = false;
        this._button.enabled = false;
    }

    protected createButton():NineSliceButton {
        const text:string = Translation.translate("CONTINUE");
        const textStyle:TextStyleOptions = this.getHarleyScaledButtonTextStyle();
        const button = new NineSliceButton(() => {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.CONTINUE);
            this.internalHarleyCompleteCallback();
        }, ` ${text} `, textStyle);
        button.enabled = false;

        return button;
    }

    private getHarleyScaledButtonTextStyle():TextStyleOptions {
        const style:TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if(typeof style.fontSize !== 'number') {
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }

    private internalHarleyCompleteCallback() {
        if(this._compCallback) {
            this.stopTimerAndDisableButton();
            this.getHarleyEndAnimation(this._compCallback);
            this._compCallback();
        }
    }

    public stopTimerAndDisableButton() {
        //this._autoCloseTimer.abort();
        this._button.enabled = false;
    }

    protected onResize(data:IResizeData):void {

        super.onResize(data);
        //this._screenRect = new PIXI.Rectangle(0, 0, data.width / this._layer.scale.x, data.height / this._layer.scale.y);
        //this._fullScreenFade.resize(0, 0, this._screenRect.width, this._screenRect.height);

        //Negate layer scaling offset.
        //this.x = -this._layer.x / this._layer.scale.x;
        //this.y = -this._layer.y / this._layer.scale.y;

        if(data.orientation === Orientation.PORTRAIT) {
            this._bonusSpineSplashSprite.position.set(360, 150);
            this._bonusSpineSplashSprite.scale.set(1, 1);
            //this._button.position.set(360, 680);
            this._button.position.set(370, 610);
            this._button.scale.set(0.9, 0.9);
        }
        else {
            this._bonusSpineSplashSprite.position.set(360, 190);
            this._bonusSpineSplashSprite.scale.set(0.9, 0.9);
            //this._button.position.set(360, 680);

            this._button.position.set(370, 590);
            this._button.scale.set(0.8, 0.8);
        }

        //this._isResizeDirty = false;
    }

    public playSpineAnimation(name:string, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void):void {

        this._bonusSplashSpine.state.setAnimation(0, name, loop);

        if(onComplete) {
            // Add callback to listener
            this._bonusSplashSpine.state.addListener({
                //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                complete: (entry:PIXI.spine.core.TrackEntry) => onComplete(entry)
                //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }
    }

    /**
     * Start animation
     *
     * @param prepareToEnterModeCallback This need to be called when the view is ready for the controller to signal other parts of the game to prepare for the new game mode. E.g change game background. This is typically called when the view fully covers the rest of the game so any layout changes will be hidden.
     * @param completeCallback Call this when the whole transition is complete. Typically when a user clicks a continue button, or when a auto close timer is complete.
     */
    getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => any): TimelineLite {
        const tl:TimelineLite = super.getStartAnimation(prepareToEnterModeCallback, completeCallback);


        this._compCallback = completeCallback;

        tl.add([
            () => {
                this._button.visible = false;
                this._button.enabled = false;
                this._mainGraphicsContainer.renderable = true;

                HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
                this._bonusSpineSplashSprite.visible = !this._winBelowStack;
                //console.log("TOTAL RESPIN WIN: " + this._totalRespinWin);

                // Play sounds and change ambience
                //#323
                !this._winBelowStack && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.FREESPIN_OUTRO);
                //SlotGame.sound.fadeAmbience(0, 0);

                this.playSpineAnimation("Start", false, (entry:PIXI.spine.core.TrackEntry) => {

                    if(entry.animation.name === "Start") {
                        this.playSpineAnimation("idle", true);
                    }
                });
            },
            HarlequinGameModuleConfig.countUpView.fadeAndRemove(0)
        ]);
        tl.add(() => {
            SlotGame.sound.fadeAmbience(0, 0);
        },  "+=0.536");
        const countUpPosition: number = this._winBelowStack ? 0.05 : 0.3; // #323
        tl.add([
            this.getCountAnimation()
        ], "+=" + countUpPosition);
        tl.add(() => {
            !this._winBelowStack && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.FREESPIN_OUTRO_ENDS);

            this._button.visible = true;
            this._button.enabled = true;
        }, "+=0.5");
        tl.add(() => {
            SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.MAIN_GAME_AMBIANCE);
            SlotGame.sound.fadeAmbience(1,1000);
        }, "+=0.429");

        this._tl = tl;
        return tl;
    }


    protected getCountAnimation():Timeline {
        const tl:TimelineLite = new TimelineLite();
        let count: TimelineLite;
        const duration: number = this._winBelowStack ? 0 : 0.5; // #323
        if(!this._winBelowStack && this._winRatio > 10) {
            count = HarlequinGameModuleConfig.countUpView.getWinStepAnimation(0, this._totalWin, duration);
        }
        else {
            count = HarlequinGameModuleConfig.countUpView.getWinStepAnimation(this._totalWin, this._totalWin, duration);
        }


        tl.add([
            count,
            () => {
                if (duration === 0) {
                    // do nothing // #323
                } else if (this._winRatio > 10) {
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.COUNTUP)
                } else {
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.COUNTUP_ENDS)
                }
            }]);
        tl.add(() => {
            SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.COUNTUP);
            if(!this._winBelowStack && this._winRatio > 10) {
                SlotGame.sound.playEffect(HarlequinSoundConfig.instance.COUNTUP_ENDS);
            }
            (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("basegame");
        });

        return tl;
    }

    /**
     * End animation, this animation is played after the completeCallback is called.
     */
    getHarleyEndAnimation(completeCallback: () => any): TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            //if(this._toMode !== "FREESPIN") {
                //SlotGame.sound.fadeAmbience(0, 50);
                //SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.MAIN_GAME_AMBIANCE);
                //SlotGame.sound.fadeAmbience(1, 50);
            //}
        });
        tl.add([
                TweenLite.to(this._bonusSpineSplashSprite, 0.8,{alpha: 0}),
                //new TweenLite(this._mainGraphicsContainer, 0.5, {alpha : 0, ease : Linear.easeNone}),
                this._fullScreenFade.getFadeOut(1),
                HarlequinGameModuleConfig.countUpView.fadeAndRemove(0.8)
            ]
        );
        //tl.add(() => completeCallback());
        tl.add(() => {
            SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.COUNTUP);
            this._bonusSpineSplashSprite.visible = false;
            this._bonusSpineSplashSprite.alpha = 1;
            this._bonusSplashSpine.state.setEmptyAnimation(0, 0);
            this._layer.removeChild(this);
        }, 1);
        tl.add(() => {
            //completeCallback();
        }, tl.totalDuration() + .5);

        this._tl = tl;
        return tl;
    }

    prepare(data: HarlequinParsedGameData): void {
        this._totalWin = data.totalWin;
        this._winRatio = this._totalWin/data.playedBetValue;
        this._finishCalled = false;
        this._toMode = data.nextMode;

        // TODO: calculate duration based on totalWin/bet
        // #323
        HarlequinGameConfig.instance.WIN_BELOW_STAKE = HarlequinGameModuleConfig.featurePrice.isWinBelowStake();
        this._winBelowStack = HarlequinGameModuleConfig.featurePrice.isWinBelowStake();
    }


    getEndAnimation():TimelineLite {
        const tl:TimelineLite = super.getEndAnimation();
        tl.eventCallback('onComplete', () => {
            this._mainGraphicsContainer.renderable = false;
        });
        //SlotGame.sound.fadeAmbience(0, 50);
        //SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.MAIN_GAME_AMBIANCE);
        //SlotGame.sound.fadeAmbience(1, 50);
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        HarlequinGameModuleConfig.featurePrice.reset();
        //EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: "NORMAL"}));
        //tl.add(this.getHarleyEndAnimation(this._compCallback));
        return tl;
    }
}